import "./styles.scss";
import DeskTop from "./desktopHeader";
import Mobile from "./mobileHeader";
import React, { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import API from "../../config/API";
import {
  useGetSettings,
  useLoadCartItems,
  useLoadCategories,
  useRefreshUser,
  useLoadOffers,
} from "./fetchingDatas";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../../redux/slices/cartSlice";
import { clearStore } from "../../redux/slices/storeSlice";
import { logout } from "../../redux/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
import { logoutChannel } from "../../logout";
import { GET } from "../../utils/apiCalls";
import { storeLiverate } from "../../redux/slices/liverateSlice";
function Header(props: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Notifications, contextHolder] = notification.useNotification();
  useEffect(() => {
    goldRate();
  }, []);
  const goldRate = async () => {
    try {
      const url = API.LIVERATE_GET;
      const response: any = await GET(url, null);

      if (response) {
        let ratesData: any = response?.data?.sort((a: any, b: any) => a.id - b.id);
        let filtData = ratesData.filter((item: any) => item.id != 5);
        dispatch(storeLiverate(filtData));
      }
    } catch (error) {
      console.error(error);
    }
  };



  const signoutUser = () => {
    Notifications["warning"]({
      message: `Your Session Expired`,
      description: "Please sign in again to continue",
    });
    logoutChannel.postMessage("Logout");
    dispatch(clearCart(null));
    dispatch(clearStore(null));
    dispatch(logout(null));
    navigate("/");
    return;
  };
  useLoadCategories();
  useLoadCartItems();
  useGetSettings();
  useRefreshUser();
  useLoadOffers();
  const Token = useSelector((state: any) => state?.User?.user?.token);
  if (Token) {
    const decoded: any = jwtDecode(Token);
    let currentDate = new Date();
    if (decoded.exp && decoded.exp * 1000 < currentDate.getTime()) {
      signoutUser();
    }
  }
  return (
    <div>
      {contextHolder}
      <div className="Header-desktop">
        <DeskTop />
      </div>
      <div className="Header-mobile">
        <Mobile />
      </div>
    </div>
  );
}
export default Header;
